import React from 'react';

export const RadioButton = ({ id, title, name, checked, onChange, customClass, value }) => {
  return (
    <div className={`radioButton ${customClass} ${checked ? 'checked' : ''}`}>
      <label htmlFor={id}>
        <span className="radioButtonTitle">{title}</span>
        <input
          type="radio"
          name={name}
          checked={checked}
          onChange={() => onChange(value)}
          className="radioInput"
          id={id}
          value={value}
        />
        <span className="control" />
      </label>
    </div>
  );
};
